import { render, staticRenderFns } from "./CacheAdministration.vue?vue&type=template&id=128de348&"
import script from "./CacheAdministration.vue?vue&type=script&lang=js&"
export * from "./CacheAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128de348')) {
      api.createRecord('128de348', component.options)
    } else {
      api.reload('128de348', component.options)
    }
    module.hot.accept("./CacheAdministration.vue?vue&type=template&id=128de348&", function () {
      api.rerender('128de348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/CacheAdministration.vue"
export default component.exports